var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bxi9ryu4ua)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4 8A7.4 7.4 0 1 1 .6 8a7.4 7.4 0 0 1 14.8 0z",
    stroke: "#233145",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.024 5.971c0 .378-.12.679-.361.902a1.252 1.252 0 0 1-.882.335c-.208 0-.413-.026-.615-.078a6.559 6.559 0 0 1-.524-.156 1.885 1.885 0 0 0-.305.313c-.135.161-.286.356-.456.586.155.665.28 1.137.377 1.417.095.279.186.563.272.85.074.228.183.407.325.536.144.129.369.193.678.193.113 0 .254-.021.423-.065.17-.043.309-.087.417-.13l-.144.589c-.43.184-.805.317-1.125.399a3.43 3.43 0 0 1-.86.125c-.182 0-.361-.018-.54-.052a1.438 1.438 0 0 1-.487-.189 1.473 1.473 0 0 1-.407-.357 1.908 1.908 0 0 1-.283-.6 5.1 5.1 0 0 1-.144-.547 9.051 9.051 0 0 0-.132-.541c-.126.188-.217.326-.273.417-.057.092-.14.22-.247.385-.343.525-.641.899-.893 1.123a1.316 1.316 0 0 1-.905.335.945.945 0 0 1-.677-.267.917.917 0 0 1-.28-.696c0-.387.12-.691.36-.916.243-.223.537-.335.886-.335.208 0 .408.025.6.075.192.05.372.105.54.166a3.1 3.1 0 0 0 .305-.307c.137-.151.285-.34.446-.566A26.008 26.008 0 0 0 6.759 7.6a69.647 69.647 0 0 0-.282-.879 1.182 1.182 0 0 0-.34-.538c-.146-.128-.368-.191-.663-.191-.131 0-.276.023-.437.068a6.377 6.377 0 0 0-.403.127l.143-.589c.39-.175.76-.307 1.109-.394.35-.088.642-.131.876-.131.213 0 .395.016.547.046.15.03.312.095.48.195.156.095.292.216.407.361.115.145.21.344.283.596.054.174.102.354.146.54l.112.482c.09-.139.186-.282.283-.43.097-.148.18-.278.25-.391.335-.525.634-.902.899-1.13A1.33 1.33 0 0 1 11.066 5c.273 0 .5.09.684.27a.943.943 0 0 1 .274.701z",
    fill: "#233145"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bxi9ryu4ua"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFilter);
export default __webpack_public_path__ + "static/media/profile-filter.fbce9ca7320d9911d4e098da450d16aa.svg";
export { ForwardRef as ReactComponent };